import Player from '@vimeo/player';

export default {
	init() {

		document.body.classList.add('scrollin');

		// workaround for video not playing when page is loaded w/ hash in URL
		if (window.location.hash) {
			// hide logo
			const headerLogo = document.getElementById('homepage-header-logo');
			headerLogo.style.opacity = 0;

			// remove hash & scroll to top
			history.pushState('', '', window.location.pathname);
			// window.scroll(0, 0);

			// show logo
			setTimeout(() => {
				headerLogo.style.opacity = '';
			}, 750);
		}
	},

	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired

		// * * * * * * * * * * * * * * * //
		// PROJECT-SPECIFIC JS //
		// * * * * * * * * * * * * * * * //

		let homepage = Array.from(document.body.classList).includes('home');

		let startingAtTop = false;

		// On every load, let's scroll to the very top of the window
		const scrollToTop = () => {
			console.log('scrolling to top');
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'instant',
			});
		}
		const initialScrollPosInterval = setInterval(() => {
			console.log('window.scrollY', window.scrollY);
			console.log('running interval')
			if (window.scrollY != 0) {
				scrollToTop();
			} else {
				startingAtTop = true;
				clearInterval(initialScrollPosInterval);
			}
		}, 250);

		// Intercept all clicks on anchors with internal anchor links (href="#...")
		// and scroll to the target instead of jumping to it with native behavior
		document.querySelectorAll('a[href^="#"]').forEach(anchor => {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				const target = document.querySelector(this.getAttribute('href'));
				if (target) {
					window.scrollTo({
						top: target.offsetTop,
						left: 0,
						behavior: 'smooth',
					});
				}
			});
		});



		const activateHomepageScroll = () => {


			/* LOAD VIDEO BASED ON SECTION */

			let windowWidth = window.innerWidth;

			const options = {
				width: windowWidth,
				muted: true,
				loop: true,
				byline: false,
				portait: false,
				title: false,
				controls: false,
				quality: '1080p',
			};

			const videoElements = {
				'video-1': { id: '851723559', loop: true },
				'video-2': { id: '851690743', loop: true },
				'video-3': { id: '850676651', loop: false, playbackRate: 1.25 },
				'video-4': { id: '844725119', loop: false },
			};

			const players = {};
			const playerArray = [];

			// let player;
			let playerStatus = 'playing';

			// Create video player objects
			for (const videoId in videoElements) {
				// console.log('videoId', videoId);
				const playerElement = document.getElementById(videoId);
				const videoOptions = {
					...options,
					id: videoElements[videoId].id,
					loop: videoElements[videoId].loop,
				};

				const player = new Player(playerElement, videoOptions);

				// set playback rate for video if it exists
				if (videoElements[videoId].playbackRate) {
					player.setPlaybackRate(videoElements[videoId].playbackRate).then(playbackRate => {
						// console.log(`playback rate set for ${videoId}`);
					}).catch(error => {
						console.error(error);
					})
				}

				// Add player to object
				players[videoId] = player;
				playerArray.push(player);

				// Set initial state & buffer video
				// console.log('playing')
				player.play().then(() => {
					setTimeout(() => {
						player.pause().then(() => player.setCurrentTime(0)).catch((error) => console.error(error));
					}, 50);
				}).catch((error) => console.error(error))

				// when buffered, let's add a class to the video container
				const playerParent = document.getElementById(videoId);
				// console.log('playerParent', playerParent);
				player.on('bufferend', () => {
					setTimeout(() => {
						playerParent.classList.add('buffered');
					}, 250);
				})

				// 1s fallback in case buffered doesn't fire
				player.on('play', () => {
					if (!playerParent.classList.contains('buffered')) {
						setTimeout(() => {
							if (!playerParent.classList.contains('buffered')) {
								playerParent.classList.add('buffered');
							}
						}, 1000);
					}
				})
			}


			const intersectionOptions = {
				threshold: 0.5,
			}

			// New
			// console.log('players', players);
			const keyframeSections = document.querySelectorAll('.keyframe-section');

			const sectionObserver = new IntersectionObserver(entries => {
				entries.forEach(entry => {

					const videoId = entry.target.dataset.videoId;
					const videoContainer = document.getElementById(videoId);
					// console.log('videoContainer', videoContainer);
					const player = players[videoId];

					const fixedContainer = entry.target.querySelector('.fixed-container');

					let pauseTimer;
					let playTimer;

					if (!entry.isIntersecting) {

						entry.target.classList.remove('in-view');

						if (player) {
							clearTimeout(pauseTimer);
							clearTimeout(playTimer);


							// Skip this on initial load
							if (videoContainer.classList.contains('initial-load')) {

								const isPaused = document.body.classList.contains('paused');
								videoContainer?.classList.add('not-playing');

								if (!isPaused && videoId !== 'video-4') {
									pauseTimer = setTimeout(() => {
										player.pause().then(() => {
											player.setCurrentTime(0);
										}).catch(error => {
											console.error('Error pausing the video:', error);
										});
										// console.log(`actually pausing ${videoId}`);
									}, 1000);
									fixedContainer?.classList.remove('fixed');
								}

							} else {
								// Set class so we don't skip the next time this fires
								videoContainer.classList.add('initial-load');
							}
						}


					} else {
						entry.target.classList.add('in-view');

						if (player) {
							const isPaused = document.body.classList.contains('paused');

							fixedContainer.classList.add('fixed');

							clearTimeout(pauseTimer);
							clearTimeout(playTimer);


							playTimer = setTimeout(() => {
								if (!isPaused) {
									player.play().then(() => {
										videoContainer.classList.remove('not-playing');
									})
										.catch(error => {
											console.error('Error playing the video:', error);
										});
								}
							}, 50);
						}

					}
				});
			}, intersectionOptions);

			keyframeSections.forEach(section => {
				sectionObserver.observe(section);
			});


			/* GLOBAL PAUSE BUTTON */


			// Get the button
			let btn = document.getElementById('pauseButton');

			// Pause and play the video, and change the button text
			function pauseMovements() {
				const isPaused = document.body.classList.contains('paused');
				const keyframeSections = document.querySelectorAll('.keyframe-section');
				if (isPaused) {
					document.body.classList.remove('paused');
					btn.classList.remove('paused');
					keyframeSections.forEach(section => {
						section.classList.remove('paused');
					})
				} else {
					btn.classList.add('paused');
					document.body.classList.add('paused');
					keyframeSections.forEach(section => {
						section.classList.add('paused');
					})
					playerArray.forEach(player => {
						player.pause();
					})
				}
			}

			if (btn) {
				btn.addEventListener('click', e => {
					pauseMovements();
				});
			}

			// End homepage stuff?

			/* ON SCROLL FUNCTIONS */


			let homepageHeaderLogo = document.getElementById(
				'homepage-header-logo'
			);
			let logoImg = document.getElementById('header-logo-img');
			let heroLogo = document.getElementById('hero-logo');
			let logoImgWhite = document.getElementById('header-logo-img-white');

			let globalHeaderLogo = document.getElementById('header-logo');

			let scrollpos = window.scrollY;
			let prevScrollpos = window.scrollY;

			let header = document.getElementById('header');

			if (homepage) {
				homepageHeaderLogo.classList.add('homepage');
				globalHeaderLogo.classList.add('homepage');
			}

			function logoShrink() {
				if (heroLogo) {
					if (
						document.body.scrollTop > 5 ||
						document.documentElement.scrollTop > 5
					) {
						logoImg.classList.add('shrink');
						heroLogo.classList.add('fade');
						logoImgWhite.classList.add('show');
						homepageHeaderLogo.classList.add('shrink');
					} else {
						logoImg.classList.remove('shrink');
						heroLogo.classList.remove('fade');
						logoImgWhite.classList.remove('show');
						homepageHeaderLogo.classList.remove('shrink');
					}
				}
			}

			function hideHeader() {
				let currentScrollPos = window.pageYOffset;
				if (currentScrollPos <= 500) {
					header.style.top = '0px';
				} else {
					document.getElementById('header').style.top = '-110px';
				}
				prevScrollpos = currentScrollPos;
			}

			function scrollPosition() {
				scrollpos = window.scrollY;
				if (scrollpos >= 500) {
					logoShrink();
				}
			}

			window.onscroll = function () {
				logoShrink();
				hideHeader();
			};

			// window.onload = function () {
			// 	scrollPosition();
			// };


			// new text sliders
			const delay = 750;
			const transition = `transform ${(delay / 3) / 1000}s ease-in-out`; // Initial transition effect
			const newTextSliders = document.querySelectorAll('.newTextSlider');

			newTextSliders.forEach(textSlider => {

				const slideContainer = textSlider.querySelector('.slides');
				const slides = textSlider.querySelectorAll('.slide');
				const count = slides.length;

				slideContainer.style.transition = transition;

				slides.forEach(slide => {
					const clone = slide.cloneNode(true);
					clone.setAttribute('aria-hidden', true);
					slideContainer.appendChild(clone);
				})

				let currentOffset = 0
				const loop = setInterval(() => {

					++currentOffset;

					slideContainer.style.transform = `translate3d(0, -${currentOffset}em, 0)`;

					// If we've ended the loop
					if (currentOffset >= count) {

						// Reset counter to zero
						currentOffset = 0;


						setTimeout(() => {
							// Remove the transition effect after the previous one wraps up
							slideContainer.style.transition = 'transform 0s linear';

							setTimeout(() => {
								// Set the container back to the top
								slideContainer.style.transform = `translate3d(0, -${currentOffset}em, 0)`;

								setTimeout(() => {
									// Add that transition effect back in so it continues smoothly
									slideContainer.style.transition = transition;

								}, delay / 4); // Just
							}, delay / 3); // Some
						}, delay / 3); // Math
					}
				}, delay); // one loop cycle
			})


			// Scroll control;

			let lastScrollPos = 0;
			let scrollTimer = null;
			// let isScrollin = false;

			// Utility function
			const scrollIntoView = (section) => {
				// document.body.classList.add('scrollin');
				// console.log('scrolling into view', section);
				section.scrollIntoView();
				// isScrollin = true;
			}

			const sectionScroll = (direction) => {

				// Get current section
				let sections = document.querySelectorAll('.keyframe-section, footer');
				let currentSection = null;
				let nextSection = null;
				let previousSection = null;

				let videoSection =

					sections.forEach(section => {
						if (section.classList.contains('in-view')) {
							currentSection = section;
						}
					});


				if (currentSection) {
					nextSection = currentSection.nextElementSibling;
					previousSection = currentSection.previousElementSibling;

					if (nextSection.classList.contains('all-videos')) {
						nextSection = document.querySelector('footer');
					}

					if (previousSection.classList.contains('all-videos')) {
						previousSection = document.getElementById('sticky-4');
					}

					if (previousSection.classList.contains('hero')) {
						previousSection = document.querySelector('main.main');
					}
				}


				if (direction === 'down') {
					if (nextSection) {
						scrollIntoView(nextSection);
					} else {
						// window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
						window.scrollBy({ top: 10, behavior: 'instant' });
						scrollActive = false;
						clearTimeout(scrollActiveTimer);
					}
				} else if (direction === "up") {
					if (previousSection) {
						scrollIntoView(previousSection);
					} else {
						// window.scrollBy({ top: window.innerHeight * -1, behavior: "smooth" });
						window.scrollBy({ top: -10, behavior: 'instant' });
						scrollActive = false;
						clearTimeout(scrollActiveTimer);
					}
				}

			}

			let scrollCooldown = 3000;
			let scrollActive = false;
			let scrollActiveTimer;

			window.addEventListener('keydown', e => {
				// console.log('e.key', e.key);
				if (e.key === "ArrowDown") {
					sectionScroll('down');
				} else if (e.key === 'ArrowUp') {
					sectionScroll('up');
				}
			})

			// Top of page button
			const topButton = document.getElementById('topButton');
			topButton.addEventListener('click', e => {
				e.preventDefault();
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				})
			})

			// Bottom of page button
			const bottomButton = document.getElementById('bottomButton');
			bottomButton.addEventListener('click', e => {
				e.preventDefault();
				const documentHeight = Math.max(
					document.body.scrollHeight, document.body.offsetHeight,
					document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight
				);
				// console.log('documentHeight', documentHeight);
				window.scrollTo({
					top: documentHeight,
					left: 0,
					behavior: 'smooth'
				})
			});

			//Show bottom button at section 4 or below
			const sticky4 = document.getElementById('sticky-4');
			function handleScroll() {
				const targetElementPosition = sticky4.getBoundingClientRect().top;

				// Get the scroll position relative to the top of the viewport
				// const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

				// console.log(targetElementPosition);
				if (targetElementPosition <= 100) {
					// The scroll position is at or below the target element
					// Run your code here
					// console.log("Scroll position is at or below the target element.");
					// You can call your function or do whatever you need to do here
					bottomButton.classList.add('active');
				} else {
					bottomButton.classList.remove('active');
				}
			}

			// Add a scroll event listener to the window
			window.addEventListener('scroll', handleScroll);
		}

		let shouldIStartInterval = setInterval(() => {
			if (startingAtTop) {
				activateHomepageScroll();
				clearInterval(shouldIStartInterval);
			}
		}, 50);



	},

};
